import {Component, Input} from '@angular/core';
import {ApiService} from '../shared/api.service';

@Component({
    selector: 'taxonomies-component',
    templateUrl: 'taxonomies.component.html'
})
export class TaxonomiesComponent {
    private _taxonomies = []
    @Input('taxonomies') 
    set taxonomies(taxonomies) {
        this._taxonomies = Object.keys(taxonomies);
    }
    get taxonomies() {
        return this._taxonomies;
    }

    constructor(private api: ApiService) {}
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/fields/taxonomies.component.ts